import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import * as Services from '../../../sdk/services';
import {
  ACESSO_SISTEMA_LOGIN_BEGIN, ACESSO_SISTEMA_LOGIN_DISMISS_ERROR, ACESSO_SISTEMA_LOGIN_FAILURE, ACESSO_SISTEMA_LOGIN_SUCCESS
} from './constants';

export function login(credenciais, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: ACESSO_SISTEMA_LOGIN_BEGIN,
    data: credenciais,
    callback,
  };
}

export function dismissLoginError() {
  return {
    type: ACESSO_SISTEMA_LOGIN_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on ACESSO_SISTEMA_LOGIN_BEGIN actions
export function* doLogin(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    const UsuarioApi = new Services['UsuarioApi']();
    let usuario = yield UsuarioApi.login(action.data);

    res = { usuario };
  } catch (err) {
    yield put({
      type: ACESSO_SISTEMA_LOGIN_FAILURE,
      data: { error: err },
      callback: action.callback,
    });

    if (action.callback) {
      action.callback(ACESSO_SISTEMA_LOGIN_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: ACESSO_SISTEMA_LOGIN_SUCCESS,
    data: res,
    callback: action.callback,
  });

  if (action.callback) {
    action.callback(ACESSO_SISTEMA_LOGIN_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchLogin() {
  yield takeLatest(ACESSO_SISTEMA_LOGIN_BEGIN, doLogin);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case ACESSO_SISTEMA_LOGIN_BEGIN:
      return {
        ...state,
        loginPending: true,
        loginError: null,
      };
    case ACESSO_SISTEMA_LOGIN_SUCCESS:
      return {
        ...state,
        usuario: action.data.pessoa,
        accessTokens: action.data.usuario,
        loginPending: false,
        loginError: null,
      };

    case ACESSO_SISTEMA_LOGIN_FAILURE:
      return {
        ...state,
        loginPending: false,
        loginError: action.data.error,
      };

    case ACESSO_SISTEMA_LOGIN_DISMISS_ERROR:
      return {
        ...state,
        loginError: null,
      };

    default:
      return state;
  }
}
export { CookieBrowser } from '../../../sdk/storage/cookie.browser';




// WEBPACK FOOTER //
// ./src/features/acesso-sistema/redux/login.js